import { useId, type InputHTMLAttributes } from "react";

interface CheckboxFieldProps extends Omit<InputHTMLAttributes<HTMLInputElement>, "type"> {
  label: string;
  error?: string | undefined;
}

export function CheckboxField({ label, error, id: suppliedId, ...props }: CheckboxFieldProps) {
  const generatedId = useId();
  const id = suppliedId ?? generatedId;
  return (
    <div className="form-group form-check">
      <input {...props} id={id} type="checkbox" className={`form-check-input ${error ? "is-invalid" : ""}`} aria-invalid={Boolean(error)} aria-describedby={error ? `${id}-error` : undefined} />
      <label className="form-check-label" htmlFor={id}>{label}</label>
      {error && <div id={`${id}-error`} className="invalid-feedback d-block">{error}</div>}
    </div>
  );
}
